(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ilayha-house"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-house]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const entry=root.querySelector('[data-entry]'),content=root.querySelector('[data-house-content]'),enter=root.querySelector('[data-enter]'),video=root.querySelector('video'),motion=root.querySelector('[data-motion]'),reduced=matchMedia('(prefers-reduced-motion:reduce)');let paused=reduced.matches,entered=false,opening=false;video.addEventListener('loadeddata',()=>video.classList.add('is-ready'),{once:true});if(video.readyState>=2)video.classList.add('is-ready');const sync=()=>{if(!entered||paused||document.hidden)video.pause();else video.play().catch(()=>{paused=true;motion.textContent=motion.dataset.play;motion.setAttribute('aria-pressed','true');});root.classList.toggle('ih-paused',paused||document.hidden);motion.textContent=paused?motion.dataset.play:motion.dataset.pause;motion.setAttribute('aria-pressed',String(paused));};const reveal=async(animate=true)=>{if(entered||opening)return;opening=true;enter.setAttribute('aria-busy','true');entered=true;content.hidden=false;root.classList.add('ih-entered');if(animate)content.classList.add('is-revealing');entry.classList.add('is-leaving');root.querySelector('#house').focus({preventScroll:true});enter.removeAttribute('aria-busy');sync();if(animate&&!reduced.matches)setTimeout(()=>{entry.hidden=true;},720);else entry.hidden=true;};enter.addEventListener('click',()=>reveal());entry.addEventListener('keydown',event=>{if(event.key==='Tab'){event.preventDefault();enter.focus();}});motion.addEventListener('click',()=>{paused=!paused;sync();});document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',event=>{paused=event.matches;sync();});if(root.querySelector('[data-form-result]'))reveal(false);else enter.focus({preventScroll:true});sync();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilayha-password"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ip-motion]').forEach(button=>{button.addEventListener('click',()=>{const paused=button.closest('.ip').classList.toggle('ip-paused');button.textContent=paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-pressed',String(paused));});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
